import PlatformRoles from '../modules/platformRoles/PlatformRoles';
import BillingAccounts from '../modules/billingAccounts/BillingAccounts';
import AuthorizationDecisions from '../modules/authorizationDecisions/AuthorizationDecisions';
import { AccessSession } from '../shared/access/AccessControls';
import { ProtectedPage, LandingPage } from './ProtectedPage';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Auth from '../modules/auth/Auth';
import Dashboard from '../modules/dashboard/Dashboard';
import { Paths } from './routes';
import NotFound from '../shared/components/NotFound';
import Profiles from '../modules/profiles/Profiles';
import Companies from '../modules/companies/Companies';
import CompaniesStats from '../modules/companies/CompaniesStats';
import Profile from '../modules/profiles/Profile';
import Tags from '../modules/tags/Tags';
import Company from '../modules/companies/Company';
import Tag from '../modules/tags/Tag';
import Deliveries from '../modules/deliveries/Deliveries';
import Templates from '../modules/templates/Templates';
import DeliveryDetails from '../modules/deliveries/DeliveryDetails';
import Usages from '../modules/usages/Usages';
import Usage from '../modules/usages/Usage';
import EmailNotifications from '../modules/emailNotifications/EmailNotifications';
import PricingPlans from '../modules/pricingPlans/PricingPlans';
import SignupRequests from '../modules/signupRequests/SignupRequests';
import DeletionRequests from '../modules/deletionRequests/DeletionRequests';
import Settings from '../modules/settings/Settings';
import IntegrationDefinitions from '../modules/integrationDefinitions/IntegrationDefinitions';
import MediaLibraryTags from '../modules/mediaLibraryTags/MediaLibraryTags';
import MediaLibraryTag from '../modules/mediaLibraryTags/MediaLibraryTag';
import ControlSettings from '../modules/controlSettings/ControlSettings';
import ContentSettings from '../modules/contentSettings/ContentSettings';
import SignupRequestPage from '../modules/signupRequestPage/signupRequestPage';
import ShareDashboardEntry from '../modules/shareDashboard/ShareDashboardEntry';

const AuthedRoutes = () => {
  return (
    <AccessSession><Routes>
      <Route path={Paths.platformRoles} element={<ProtectedPage><PlatformRoles /></ProtectedPage>} />
      <Route path={Paths.authorizationDecisions} element={<ProtectedPage><AuthorizationDecisions /></ProtectedPage>} />
      <Route path={Paths.billingAccounts} element={<ProtectedPage><BillingAccounts /></ProtectedPage>} />
      <Route path={Paths.billingAccounts + '/:companyId'} element={<ProtectedPage><BillingAccounts /></ProtectedPage>} />
      <Route path={Paths.login} element={<Auth />} />
      <Route path={Paths.home} element={<ProtectedPage><LandingPage><Dashboard /></LandingPage></ProtectedPage>} />

      <Route path={Paths.signupRequests} element={<ProtectedPage><SignupRequests /></ProtectedPage>} />
      <Route
        path={Paths.signupRequests + '/:requestId'}
        element={<ProtectedPage><SignupRequestPage /></ProtectedPage>}
      />

      <Route path={Paths.profiles} element={<ProtectedPage><Profiles /></ProtectedPage>} />
      <Route path={Paths.profiles + '/:profileId'} element={<ProtectedPage><Profile /></ProtectedPage>} />
      <Route path={Paths.companies} element={<ProtectedPage><Companies /></ProtectedPage>} />
      <Route path={Paths.companiesStats} element={<ProtectedPage><CompaniesStats /></ProtectedPage>} />
      {/* /companies/stats listed first for readability; v6 ranks static > dynamic regardless. Stale-bundle protection lives in Company.tsx. */}
      <Route path={Paths.companies + '/:companyId'} element={<ProtectedPage><Company /></ProtectedPage>} />
      <Route path={Paths.tags} element={<ProtectedPage><Tags /></ProtectedPage>} />
      <Route path={Paths.tags + '/:tagId'} element={<ProtectedPage><Tag /></ProtectedPage>} />
      <Route path={Paths.mediaLibraryTags} element={<ProtectedPage><MediaLibraryTags /></ProtectedPage>} />
      <Route
        path={Paths.mediaLibraryTags + '/:tagId'}
        element={<ProtectedPage><MediaLibraryTag /></ProtectedPage>}
      />
      <Route path={Paths.deliveries} element={<ProtectedPage><Deliveries /></ProtectedPage>} />
      <Route path={Paths.templates} element={<ProtectedPage><Templates /></ProtectedPage>} />
      <Route path={Paths.pricingPlans} element={<ProtectedPage><PricingPlans /></ProtectedPage>} />
      <Route path={Paths.emailNotifications} element={<ProtectedPage><EmailNotifications /></ProtectedPage>} />
      <Route path={Paths.integrationDefinitions} element={<ProtectedPage><IntegrationDefinitions /></ProtectedPage>} />
      <Route path={Paths.deletionRequests} element={<ProtectedPage><DeletionRequests /></ProtectedPage>} />
      <Route path={Paths.settings} element={<ProtectedPage><Settings /></ProtectedPage>} />
      <Route path={Paths.controlSettings} element={<ProtectedPage><ControlSettings /></ProtectedPage>} />
      <Route path={Paths.contentSettings} element={<ProtectedPage><ContentSettings /></ProtectedPage>} />
      <Route
        path={Paths.deliveries + '/:deliveryId'}
        element={<ProtectedPage><DeliveryDetails /></ProtectedPage>}
      />
      <Route path={Paths.usages} element={<ProtectedPage><Usages /></ProtectedPage>} />
      <Route path={Paths.usages + '/:usageId'} element={<ProtectedPage><Usage /></ProtectedPage>} />
      <Route element={<ProtectedPage><NotFound /></ProtectedPage>} />
    </Routes></AccessSession>
  );
};

const RootRouter = () => (
  <Routes>
    {/* Single splat route keeps ShareDashboardEntry mounted across
        overview ↔ drill-down. Two sibling routes would remount it and the
        unmount cleanup would clear the token mid-transition. */}
    <Route path="/share/dashboard/*" element={<ShareDashboardEntry />} />
    <Route path="*" element={<AuthedRoutes />} />
  </Routes>
);

export default RootRouter;
